import React from 'react';
import {getDateFormatted,getStatusValue,getStatusMessageValue} from '../utils/utils'
import {Link} from 'react-router-dom'

function OrderListItem(props) {
    let order = props.order
    return (
        <div className="row" style={{paddingLeft:"15px",paddingRight:"15px"}}>
        <div className="col-10 order-dettaglio" style={{borderBottom:"1px solid grey",padding:"5px 15px"}}> 
            <div className="row" style={{textAlign:"left"}}>
                <div style={{paddingLeft:"0px"}} className="col-4">{getDateFormatted(order.timestamp.split("T"))}</div>
                <div className="col-4">{order.selected_payment ? order.total + "€" : null }</div>
                {/* <div className="col-5">{order.order_id}</div> */}
                {order.status === "paid" || order.status === "submitted_for_settlement" ? 
                    order.isPaid ? 
                    <div className="col-4">{getStatusValue("paid",'IT')}</div>
                    :
                    <div className="col-4">{getStatusValue("submitted_for_settlement",'IT')}
                        <span className="d-inline-block" tabindex="0" data-toggle="tooltip" title={getStatusMessageValue('submitted_for_settlement','IT')}>
                            <i className="fa fa-info-circle" style={{marginLeft:"5px"}}></i>
                        </span>
                    </div>
                :
                    <div className="col-4">{getStatusValue(order.status,'IT')}</div>}
            </div>
        </div>
        <div className="col-2">
           <div><Link to={"/orders/"+order.order_id}><span  className="button-resume-sm">Dettaglio</span></Link></div>
        </div>
    </div>
    );
}

export default OrderListItem;